import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import {
  ModalTrigger,
  Pagination,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel,
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper,
} from 'modules/theme';
import {
  ModalForm,
  ModalFormContainer,
} from '../../../../theme/theme1/common/styles/main';

class SmsSenderAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `SMS Sender`;
    this.moduleUrl = `setting/smsSenderConfig`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      destination: editData.destination || '',
      senderId: editData.senderId || '',
      entityId: editData.entityId || '',
      company: editData.company || '',
      brandName: editData.brandName || '',
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      Alert.success(`${data.message}`);
      this.setData();
      this.props.closeModal(true);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
	let destination = this.state.destination.trim();
	let senderId = this.state.senderId.trim();
	let entityId = this.state.entityId.trim();
	let company = this.state.company.trim();
	let brandName = this.state.brandName.trim();
	if (!(brandName && company && entityId && senderId && destination)) return Alert.error('Please enter all required fields properly');
    let tData = {
      destination,
      senderId,
      entityId,
      company,
      brandName,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            // Alert.success(data.message);
            Alert.success(`${this.moduleName} updated successfully`)
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          // Alert.success(data.message);
          Alert.success(`${this.moduleName} created successfully`)
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Destination Country', {
                defaultValue: '',
                placeholder:'Destination Country',
                autoFocus: true,
				maxLength: 50,
                required: true,
                id: 'destination',
                value: this.state.destination,
                onChange: (e) => {
                  this.setState({ destination: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Sender ID', {
                defaultValue: '',
                placeholder:'Sender ID',
                autoFocus: false,
                required: true,
				maxLength: 50,
                id: 'senderId',
                value: this.state.senderId,
                onChange: (e) => {
                  this.setState({ senderId: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('DLT Entity/PE ID', {
                defaultValue: '',
                placeholder:'DLT Entity/PE ID',
				maxLength: 50,
                autoFocus: false,
                required: true,
                id: 'entityId',
                value: this.state.entityId,
                onChange: (e) => {
                  this.setState({ entityId: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Registered Company Name', {
                defaultValue: '',
                placeholder:'Registered Company Name',
                autoFocus: false,
				maxLength: 150,
                required: true,
                id: 'company',
                value: this.state.company,
                onChange: (e) => {
                  this.setState({ company: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('Brand Name', {
                defaultValue: '',
                placeholder:'Brand Name',
                autoFocus: false,
				maxLength: 150,
                required: true,
                id: 'brandName',
                value: this.state.brandName,
                onChange: (e) => {
                  this.setState({ brandName: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            onClick={() => this.props.closeModal()}
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type='blueModalBtn' btnType='submit'
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </ModalForm>
    );
  }
}

SmsSenderAddEdit.propTypes = {
  group: PropTypes.array,
};

SmsSenderAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default SmsSenderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsSender/components/SmsSenderAddEdit.js